export default {
    credit_cards: [],
    credit_cards_total_invoice: []
};